import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7001Model } from '../kymw7001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetReplacementListResponse = {
  RequestBuyer: string;
  FeatureCode: string;
  FeatureName: string;
  ClassCode: string;
  ClassName: string;
  MiddleClassCode: string;
  MiddleClassName: string;
  PCode: string;
  ItemCode: string;
  GuideGoodsName: string;
  GuideStandardName: string;
  PricePattern: string;
  ThisTimeSupplyPrice: string;
  ThisTimeCostPrice: string;
  PredictPlanNum: string;
  PlanNum: string;
  PlanSupplyBudget: string;
  Remarks: string;
  RequestStatus: string;
  BuyerRequestId: string;
}[];

/**
 * 差し替え対象一覧取得処理サービス
 * @export GetReplacementListService
 * @class GetReplacementListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetReplacementListService extends PlessJsonResponderSub<GetReplacementListResponse> {
  model: KYMW7001Model;
  buyerList: string[];
  private calbak: (data: GetReplacementListResponse) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetReplacementListService
   */
  private getBody(): PlessRequest {
    const searchObj = {
      GetFeatureList: {
        condition: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType,
          FeatureCode: this.model.featureCode
        },
        combination: this.buyerList.map(item => ({
          condition: {
            BuyerCode: item
          } 
        }))
      }
    }

    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetReplacementListService
   */
  execute(model: KYMW7001Model, buyerList: string[], f?: (data: GetReplacementListResponse) => void): void {
    this.model = model;
    this.buyerList = buyerList;
    if (f) this.calbak = f;
    this.send('getReplacementList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetReplacementListService
   */
  success(data: GetReplacementListResponse) {
    if (this.calbak) this.calbak(data);
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
